var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"label":"I would like to receive weekly emails","color":_vm.themes.candidate.light.input},on:{"change":_vm.submit},model:{value:(_vm.profile.receiveDigests),callback:function ($$v) {_vm.$set(_vm.profile, "receiveDigests", $$v)},expression:"profile.receiveDigests"}})
}
var staticRenderFns = []

export { render, staticRenderFns }